

export enum ActivityLogsTypes {
    Listing,
    Client,
    ListingReview,
    
}

